// extracted by mini-css-extract-plugin
module.exports = {"videoContainer":"DashboardVideoBlock__videoContainer","youtubeContainer":"DashboardVideoBlock__youtubeContainer","videoTitle":"DashboardVideoBlock__videoTitle"};